import React from "react";
import INotificationProps from "./types/index";
import styles from "./styles.module.scss";
import { ParagraphFont, HeaderCapsFont } from "../fonts";
import closeSrc from "../../assets/svgs/close_light-24px.svg";
import notificationSrc from "../../assets/svgs/notification_important-24px.svg";
import { StatusEnum } from "VideoWall/enums/status";

export const Notification = ({
  title,
  body,
  status,
  onClose
}: INotificationProps) => {
  function getStatusClass() {
    switch (status) {
      case StatusEnum.SUCCESS:
        return styles.success;
      case StatusEnum.ERROR:
        return styles.error;
      default:
        return styles.info;
    }
  }
  return (
    <div className={`${styles.root} ${getStatusClass()}`}>
      <div className={styles.title}>
        <HeaderCapsFont>{title}</HeaderCapsFont>
      </div>
      <div className={styles.body}>
        <ParagraphFont>{body}</ParagraphFont>
      </div>
      <img
        className={styles.close}
        src={closeSrc}
        alt="close"
        onClick={onClose}
      />
      <img className={styles.icon} src={notificationSrc} alt="notification" />
    </div>
  );
};
